import { INDEX_NAME } from "../../interfaces";
import { searchEs } from "../../api/fetchesApiSearch";
const getPropagation = async (aggregateType) => {
    const { items } = await searchEs({
        aggregateType,
        index: INDEX_NAME.CONFIG,
        data: {
            from: 0,
            size: 1,
            query: { ids: { values: ["entity_structure"] } },
        },
    });
    const version = items[0].data.version;
    const fetch1 = await searchEs({
        aggregateType,
        index: INDEX_NAME.TABULARROOT,
        data: {
            from: 0,
            size: 0,
        },
    });
    const fetch2 = await searchEs({
        aggregateType,
        index: INDEX_NAME.TABULARROOT,
        data: {
            from: 0,
            size: 0,
            query: {
                bool: {
                    must: {
                        term: { configurationVersion: version },
                    },
                },
            },
        },
    });
    const total = fetch1.itemsTotal;
    const count = fetch2.itemsTotal;
    return { count, total };
};
export default getPropagation;
